import { render, staticRenderFns } from "./ArticleTile.vue?vue&type=template&id=4715f835&"
import script from "./ArticleTile.vue?vue&type=script&lang=js&"
export * from "./ArticleTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports